export default "__VITE_ASSET__IDd9WfYa__"